import { gql } from '__generated__';

export default gql(`
  query GetOrderData($participant_id: ID!, $event_id: ID!) {
    participant(id: $participant_id) {
      id
      full_name
      email
      personal_registrations: registrations(event_id: $event_id, filters: { participants: [$participant_id] }) {
        ...GetOrderDataRegistrationFields
      }
      nonpersonal_registrations: registrations(event_id: $event_id, filters: { not_participants: [$participant_id] }) {
        ...GetOrderDataRegistrationFields
      }
      invoice_details {
        company_name
        is_charity
        reference
        street
        house_number
        extra_address_line
        zip_code
        city
        country
        phone
        vat_id
      }
    }
    event(id: $event_id) {
      id
      project {
        id
        shift_vat
      }
      title
      end_date
      payment_methods
      down_payment_deadline
      tickets {
        id
        title
        units
        business
        is_sold_out
        promotions {
          id
          title
          amount
          is_sold_out
        }
        time_slots {
          id
          start_date
          start_time
          title
          multi_date
          is_sold_out
        }
        team_type {
          id
        }
      }
      products {
        id
        title
        is_sold_out
        stand_alone
        promotions {
          id
          title
          amount
          is_sold_out
        }
        product_variants {
          id
          title
          is_sold_out
        }
      }
      coupons {
        id
        code {
          id
          value
        }
        prefix
        type
        value
        codes_count
        available
      }
      invitations {
        id
        prefix
        available
        has_unique_codes
        code {
          id
          value
        }
      }
      team_types {
        id
        title
        join_policy
      }
    }
  }

  fragment GetOrderDataRegistrationFields on Registration {
    id
    sequence
    assigned
    full_name
    promotion {
      id
      title
    }
    time_slot {
      id
      start_date
      start_time
      multi_date
    }
    ticket {
      id
      title
    }
  }
`);
